import {
    CorporateCustomer,
    PortalSalesResponse,
} from "../models/CorporateApplication";
import { EcommerceEventList } from "../models/Event";
import axios from "./axios";
import portalAxios from "./portalAxios";
import { BuildPortalUri, BuildUri } from "./BuildUri";
import { MultiPatchRequest } from "../requests/PatchRequests";

class SpecialDepartmentEndpoints {
    static async getEventList(code: string) {
        return (
            await axios.get<EcommerceEventList>(
                BuildUri(`/sales/special-events/{code}`, { code }),
            )
        ).data;
    }

    static async getApplication(code: string, password: string) {
        return (
            await portalAxios.get<PortalSalesResponse>(
                BuildPortalUri(`/corporate-public/portal/{code}`, { code }),
                {
                    headers: {
                        authorization: password,
                    },
                },
            )
        ).data;
    }

    static async editCustomer(
        code: string,
        password: string,
        request: MultiPatchRequest,
    ) {
        return (
            await portalAxios.patch<CorporateCustomer>(
                BuildPortalUri(`/corporate-public/portal/{code}`, { code }),
                request,
                {
                    headers: {
                        authorization: password,
                    },
                },
            )
        ).data;
    }

    static async getFlyer(code: string, password: string): Promise<string> {
        return (
            await portalAxios.get<string>(
                BuildPortalUri(`/corporate-public/portal/{code}/flyer`, {
                    code,
                }),
                {
                    headers: {
                        authorization: password,
                    },
                    responseType: "blob",
                },
            )
        ).data;
    }

    static async createApplication(request: any): Promise<void> {
        return (
            await portalAxios.post<void>(
                BuildPortalUri(`/corporate-public/application`),
                request,
            )
        ).data;
    }
}

export default SpecialDepartmentEndpoints;
